import React from "react"
import SEO from "../components/Global/SEO/seo"
import Layout from "../components/Global/Layout/Layout"
import styled from "styled-components"
import {
  BlurredCircleContainer,
  BlurredCircleLeft,
  BlurredCircleRight,
} from "../components/Global/Common/BlurredCircle/BlurredCircle"
import { FlexipageColors } from "../components/Flexipage/Global/FlexipageStyles"
import HomeHero from "../components/HomeV2/HomeHero/HomeHero"
import HomeBrandsMarquee from "../components/HomeV2/HomeBrandsMarquee/HomeBrandsMarquee"
import HomeCaseStudiesCarousel from "../components/HomeV2/HomeCaseStudiesCarousel/HomeCaseStudiesCarousel"
import HomePanels from "../components/HomeV2/HomePanels/HomePanels"
import HomeNews from "../components/HomeV2/HomeNews/HomeNews"
import HomeAccordion from "../components/HomeV2/HomeAccordion/HomeAccordion"

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6rem;
  margin-top: 6rem;
`

export default function HomeV2(){
  return (
    <Layout showHelpSection={false}>
      <SEO page="home" />
      <BlurredCircleContainer>
        <BlurredCircleLeft size={316} top={300} offset={-25} color={FlexipageColors.teal600} />
        <BlurredCircleRight size={366} top={250} offset={-25} color={FlexipageColors.teal600} />
        <BlurredCircleLeft size={316} top={1200} offset={-25} color={FlexipageColors.teal600} />
        <BlurredCircleRight size={316} top={1600} offset={-25} color={FlexipageColors.teal600} />

        <BlurredCircleLeft size={156} top={200} offset={-15} color={FlexipageColors.blue1000} />
        <BlurredCircleRight size={182} top={500} offset={-10} color={FlexipageColors.blue1000} />
      </BlurredCircleContainer>
      <HomeContainer>
        <HomeHero />
        <HomeBrandsMarquee />
        <HomeCaseStudiesCarousel />
        <HomePanels />
        <HomeNews />
        <HomeAccordion />
      </HomeContainer>
    </Layout>
  )
}
